import { AppRouter } from './router';
import { ClassCodeProvider } from './context/ClassCodeContext';
import { InstallPrompt } from './components/InstallPrompt';
import { UpdatePrompt } from './components/UpdatePrompt';

export default function App() {
  return (
    <ClassCodeProvider>
      <AppRouter />
      <InstallPrompt />
      <UpdatePrompt />
    </ClassCodeProvider>
  );
}
